import { type Province, provinces } from '@lib/shared';
import lodashSortBy from 'lodash-es/sortBy';
import type { ComputedRef, Ref } from 'vue';

export type UseProvincesReturnType = ComputedRef<Province[]>;

export const useProvinces = (countryCode: Ref<string | undefined>): UseProvincesReturnType => {
    return computed<Province[]>(() => lodashSortBy(countryCode.value && countryCode.value in provinces ? provinces[countryCode.value] : []));
};
